<script setup>
// SiteUp: avisa quem está com a aba aberta quando um DEPLOY trocou o frontend
// (o bundle do vite mudou). Banner não-bloqueante "Nova versão • Atualizar" — a
// pessoa recarrega quando quiser, sem tela quebrada. Detecta comparando o manifest
// do vite (cache-busted) com o capturado ao carregar a aba. NÃO depende da versão
// do Chatwoot (isso é o UpdateBanner nativo) — é por DEPLOY nosso.
// Preview: abra qualquer tela com ?__update_demo=1 pra ver o banner na hora.
import { ref, onMounted, onBeforeUnmount } from 'vue';

const MANIFEST_URL = '/vite/.vite/manifest.json';
const POLL_MS = 5 * 60 * 1000; // checa a cada 5 min (+ ao focar/voltar pra aba)

const updateAvailable = ref(false);
const dismissed = ref(false);
let baseline = null;
let timer = null;

const fetchManifest = async () => {
  try {
    const res = await fetch(`${MANIFEST_URL}?t=${Date.now()}`, {
      cache: 'no-store',
    });
    if (!res.ok) return null;
    return await res.text();
  } catch {
    return null;
  }
};

const check = async () => {
  if (updateAvailable.value) return;
  const current = await fetchManifest();
  if (!current) return;
  if (baseline === null) {
    baseline = current; // 1ª leitura = referência desta aba
    return;
  }
  if (current !== baseline) updateAvailable.value = true;
};

const onVisibility = () => {
  if (document.visibilityState === 'visible') check();
};

const reload = () => {
  window.location.reload();
};

onMounted(() => {
  // Preview manual do banner (não afeta o uso normal).
  if (new URLSearchParams(window.location.search).has('__update_demo')) {
    updateAvailable.value = true;
    return;
  }
  check(); // captura a baseline
  timer = setInterval(check, POLL_MS);
  document.addEventListener('visibilitychange', onVisibility);
  window.addEventListener('focus', check); // checa também ao focar a janela
});

onBeforeUnmount(() => {
  if (timer) clearInterval(timer);
  document.removeEventListener('visibilitychange', onVisibility);
  window.removeEventListener('focus', check);
});
</script>

<template>
  <div
    v-if="updateAvailable && !dismissed"
    class="flex items-center justify-center w-full h-12 gap-3 px-4 text-xs font-medium text-white bg-n-brand"
  >
    <span class="flex items-center gap-1.5 min-w-0">
      <span class="flex-shrink-0 size-4 i-ri-sparkling-line" />
      <span class="truncate">Uma nova versão do sistema está disponível.</span>
    </span>
    <button
      type="button"
      class="inline-flex items-center flex-shrink-0 gap-1.5 px-3 py-1.5 text-xs font-semibold transition-colors rounded-full bg-n-slate-12 text-n-background text-n-brand hover:bg-n-solid-1"
      @click="reload"
    >
      <span class="size-3.5 i-ri-refresh-line" />
      Atualizar
    </button>
    <button
      type="button"
      title="Dispensar"
      class="inline-flex items-center justify-center flex-shrink-0 p-1 transition-colors rounded-md text-white/80 hover:bg-white/15 hover:text-white"
      @click="dismissed = true"
    >
      <span class="size-4 i-ri-close-line" />
    </button>
  </div>
</template>
